export default "__VITE_ASSET__MorW15ub__"